export default __webpack_public_path__ + "static/media/hht2_storybook_04.4db76566.png";